import { CollectionEntity } from "@busy-human/gearbox";
export var ReassignmentLog;
(function (ReassignmentLog) {
    function Default() {
        return {
            changes: {},
            changedBy: "",
            changedAt: new Date().toISOString(),
            oldOwner: "",
            newOwner: "",
            booking: ""
        };
    }
    ReassignmentLog.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults = Default;
    }
    ReassignmentLog.CollectionClass = CollectionClass;
    ReassignmentLog.Collection = new CollectionClass({ path: "/ReassignmentLog" });
})(ReassignmentLog || (ReassignmentLog = {}));
//# sourceMappingURL=index.js.map